<template>
  <div id="Planning-booking">

    <b-container fluid>
      <b-row class="mb-1 text-left">
        <b-col>
          <h1 class="labelBold">{{ this.$t(`bookingTransport.extraordinary.title`) }}</h1>
        </b-col>
        <div class="col-md-4">
          <div class="container-input">
            <input type="file" name="file-2" id="file-2" class="inputfile inputfile-2" @change="loadCSV($event)" accept=".csv" data-multiple-caption="{count} archivos seleccionados" multiple />
            <label for="file-2">
              <i style='font-size:24px' class='fas'>&#xf6dd;</i>
              <span class="iborrainputfile" id="filecsv"> {{ $t("users.search.selectFile") }}</span>
            </label>
            <i style='font-size:24px' class='fas btn-outline-secondary' @click="showInf()">&#xf05a;</i>
            <div v-if="cargaFile">
              <i style='font-size:24px; float:right;' class='fas btn-outline-secondary' @click="removeFile()">&#xf1f8;</i>
            </div>
          </div>
        </div>
        <button class="btn-confirm btn-outline-secondary" @click="SavePrePlanning">
          <!-- {{ $t("bookingTransport.planning.createPlanning") }} -->
          {{ $t("bookingTransport.CreateMassive") }}
          <i style='font-size:18px' class='fas'>&#xf0c7;</i>
        </button>
      </b-row>
    </b-container>

    <div class="row">
      <div class="col-md-12">
        <v-client-table :data="ArrayExtraordinary" :columns="table_options_extraordinary.columns" :options="table_options_extraordinary.options" ref="ExtraordinaryTable" id="ExtraordinaryTable">
          <template #period_from="props">{{props.row.period_from | formatDateOnly(appLang)}}</template>
          <template #period_to="props">{{props.row.period_to | formatDateOnly(appLang)}}</template>
          <template #route_id="props">{{ translateRoute(props.row.route_id)}} </template>
          <template #shift="props">{{ translateShift(props.row.shift)}} </template>
          <template #error="props"> <div  style="color:red;" v-if="props.row.error"> {{props.row.IdsError}} </div></template>
          <template v-slot:actions="props">
            <center>
              <i style='font-size:.9rem' class='fa btn btn-outline-secondary' @click="ModifyPrePlanning(props.row,false,'EditExtraordinary')">&#xf044;</i>
            </center>
          </template>
          <template v-slot:eliminar="props">
            <center>
              <i style='font-size:.9rem' class='fa btn btn btn-outline-danger' @click="ModifyPrePlanning(props.row,true)">&#xf1f8;</i>
            </center>
          </template>
          <div slot="filter__route_id">
            <select class="form-control" name="route_id" id ="route_id" v-model="selected" @change="filterStatus(selected)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arrayRutas"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.route_name }}
              </option>
            </select>
          </div>

          <div slot="filter__shift">
            <select class="form-control" name="shift" id ="shift" v-model="selectedIdTurno" @change="filterShift(selectedIdTurno)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arraySchedule"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.shift_name }}
              </option>
            </select>
          </div>
        </v-client-table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-server-table :columns="table_options.columns" :options="table_options.options" ref="planningTable" id="planningTable">
          <template #created_at="props">{{props.row.created_at | formatDateOnly(appLang)}}</template>
          <template #period_from="props">{{props.row.period_from | formatDateOnly(appLang)}}</template>
          <template #period_to="props">{{props.row.period_to | formatDateOnly(appLang)}}</template>
          <template #route_id="props">{{ translateRoute(props.row.route_id)}} </template>
          <template #shift="props">{{ translateShift(props.row.shift)}} </template>
          <template v-slot:actions="props">
            <center>
              <i style='font-size:24px' class='fas btn-outline-secondary' @click="ModifyPrePlanning(props.row,false,'planning')">&#xf044;</i>
            </center>
          </template>
          <div slot="filter__route_id">
            <select class="form-control" name="route_id" id ="route_id" v-model="selected" @change="filterStatusP(selected)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arrayRutas"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.route_name }}
              </option>
            </select>
          </div>
          <div slot="filter__shift">
            <select class="form-control" name="shift" id ="shift" v-model="selectedIdTurno" @change="filterShiftPla(selectedIdTurno)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arraySchedule"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.shift_name }}
              </option>
            </select>
          </div>
          <div slot="filter__created_at">
            <date-picker  id="created_at" name="created_at" @change="filterCreate(Filter_created_at)"  v-model="Filter_created_at"
                          placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
            </date-picker>
          </div>
          <div slot="filter__period_from">
            <date-picker  id="period_from" name="period_from" @change="filterFrom(Filter_period_from)"  v-model="Filter_period_from"
                          placeholder="YYYYY-MM-DD" valueType="YYYY-MM-DD" >
            </date-picker>
          </div>
          <div slot="filter__period_to">
            <date-picker  id="period_to" name="period_to" @change="filterTo(Filter_period_to)"  v-model="Filter_period_to"
                          placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
            </date-picker>
          </div>
          <template v-slot:enabled="props">
            <input
              disabled
              type="checkbox"
              :name="`select${props.row.id}`"
              :id="`select${props.row.id}`"
              :value="props.row.id"
              v-model="props.row.enabled"
            />
          </template>

          <template v-slot:carritochk="props">
            <input v-if="props.row.enabled"
                   type="checkbox"
                   :name="`select${props.row.id}`"
                   :id="`select${props.row.id}`"
                   :value="props.row"
                   v-model="carrito"
                   @click="chkMassive(props.row,$event)"
            />
          </template>

          <button v-if="carrito.length>0"
                  class="btn-AddStops btn-outline-secondary"
                  slot="beforeLimit"
                  type="primary"
                  @click="CancelationMassive">
            {{$t('bookingTransport.cancelationMassive')}}

          </button>

        </v-server-table>
      </div>
    </div>
    <b-modal size="lg" centered ref="add-Stops" no-close-on-backdrop  :title="$t('bookingTransport.planning.addRoutes')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100">
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.addStop')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">

        <v-client-table :data="arrayAddRutas" :columns="table_optionsAddStops.columns" :options="table_optionsAddStops.options" ref="AddStops" id="AddStops">
          <template #schedule="props">{{ props.row.schedule }}</template>
          <template v-slot:Stopschk="props">
            <input
              type="checkbox"
              :name="`select${props.row.id}`"
              :id="`select${props.row.id}`"
              :value="props.row.id"
              v-model="carritoAdd"
              @click="AddChkStop(props.row,$event)"
            />
          </template>
        </v-client-table>

      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditAddConfirm()"
          >
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeAddRoute()"
          >
            {{ $t("bookingTransport.cancel") }}
          </b-button>

        </div>
      </template>
    </b-modal>

    <b-modal size="lg" centered ref="my-edit" no-close-on-backdrop  :title="$t('bookingTransport.edit')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100" v-if="DeleteStop">
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.delete')}}</p>
          </h3>
        </div>
        <div class="w-100" v-else>
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.edit')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3" v-if="DeleteStop">
          <b-col sm="1" >
            <i style="font-size:50px; color:red" class="fa">&#xf071;</i>
          </b-col>
          <b-col sm="11">
            <h4 class="labelBold">{{ $t("bookingTransport.planning.confirmDelete") }}</h4>
          </b-col>
        </b-row>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="4" class="noEditable">
            <label class="labelBold">{{ $t("bookingTransport.planning.schedule") }}</label>
            <input type="text" v-model="ScheduleValidate.shift_name" disabled/>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_time") }}</label>
            <vue-timepicker class="noEditable" v-model="ScheduleValidate.start_time" disabled></vue-timepicker>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.end_time") }}</label>
            <vue-timepicker class="noEditable" v-model="ScheduleValidate.end_time" disabled></vue-timepicker>
          </b-col>
        </b-row>
        <br/>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="2">
            <label class="labelBold">{{ $t("bookingTransport.planning.TableStops.headings.id") }}</label>
            <input type="text" v-model="id_parada" />
          </b-col>
          <b-col sm="6">
            <label class="labelBold">{{ $t("bookingTransport.planning.TableStops.headings.stop_name") }}</label>
            <input type="text" v-model="stop_name" />
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.planning.TableStops.headings.schedule") }}</label>
            <vue-timepicker v-model="schedule"></vue-timepicker>
          </b-col>
        </b-row>
        <br/>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="2" class="noEditable">
            <label class="labelBold">{{ $t("bookingTransport.planning.TableStops.headings.route_id") }}</label>
            <input type="text" v-model="route_id" disabled />
          </b-col>
          <b-col sm=6>
            <label class="labelBold">{{ $t("bookingTransport.planning.TableStops.headings.route_description") }}</label>
            <input type="text" v-model="route_descriptionStop" />
          </b-col>
          <b-col sm="4">
            <label class="labelBold">{{ $t("bookingTransport.planning.TableStops.headings.coordenates") }}</label>
            <input type="text" v-model="coordenates" />
            <!-- <div v-if="$v.coordenates.$error" class="error-msg">
             <p v-if="!$v.coordenates.required">{{$t("bookingTransport.Stops.TableStops.headings.coordenatesrequired")}}</p>
             <p v-if="!$v.coordenates.coord">{{$t("bookingTransport.Stops.TableStops.headings.coordenatesinvalid")}}</p>
            </div> -->
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirm()"
          >
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEdit()"
          >
            {{$t("bookingTransport.cancel")}}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal style="z-index:-1" size="xl" centered ref="Pre-Planning-edit" no-close-on-backdrop  :title="$t('bookingTransport.edit')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100" v-if="DeleteRowPreplanning">
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.deletePreplannign')}}</p>
          </h3>
        </div>
        <div class="w-100" v-else>
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.editPreplannign')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3" v-if="DeleteRowPreplanning">
          <b-col sm="1" >
            <i style="font-size:50px; color:red" class="fa">&#xf071;</i>
          </b-col>
          <b-col sm="11">
            <h4 class="labelBold">{{ $t("bookingTransport.planning.confirmDeletePreplanning") }}</h4>
          </b-col>
        </b-row>
        <b-row cols="1" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="3" lg="3" >
            <div class="dateInput">
              <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_from") }}</label>
              <br>
              <date-picker class="dateInput" v-model="dates.from" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
              </date-picker>
              <div v-if="$v.dates.from.$error" class="error-msg">
                <p v-if="!$v.dates.from.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_from")}}{{$t("bookingTransport.required")}}</p>
                <p v-if="!$v.dates.from.InvalidDate">{{$t("bookingTransport.planning.notCreatePlanning")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="3" lg="3" >
            <div class="dateInput">
              <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_to") }}</label>
              <br>
              <date-picker class="dateInput" v-model="dates.to" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
              </date-picker>
              <div v-if="$v.dates.to.$error" class="error-msg">
                <p v-if="!$v.dates.to.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_to")}}{{$t("bookingTransport.required")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="2" lg="2" >
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.blockedSeats")}}
              </label>
              <input type="number" v-model="blockedSeats" />
              <div v-if="$v.blockedSeats.$error" class="error-msg">
                <p v-if="!$v.blockedSeats.sits_val">{{ $t("bookingTransport.errorCapacity")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="2" lg="2">
            <div class="noEditable">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.availableSeats")}}
              </label>
              <input type="number" v-model="availableSeats" disabled/>
              <div v-if="$v.availableSeats.$error" class="error-msg">
                <p v-if="!$v.availableSeats.sits_val">{{ $t("bookingTransport.errorCapacity")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="2" lg="2">
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.capacity")}}
              </label>
              <input type="number" v-model="capacity"/>
              <div v-if="$v.capacity.$error" class="error-msg">
                <p v-if="!$v.capacity.ids">{{ $t("bookingTransport.mayor")}}</p>
              </div>
            </div>
          </b-col>
        </b-row>
        <br/>

        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="2">
            <label class="black">{{ $t("bookingTransport.planning.schedule") }}</label>
            <select class="form-control" v-model="idSchedule" id="schedule" @change="showSetStops" disabled>
              <option value="0" disabled> {{$t('bookingTransport.select')}}</option>
              <option v-for="data in arraySchedule" :key="data.id" :value="data.id" v-text="data.shift_name"></option>
            </select>
            <div v-if="$v.idSchedule.$error" class="error-msg">
              <p v-if="!$v.idSchedule.required">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p>
            </div>
          </b-col>
          <b-col sm="2">
            <label class="black">{{ $t("bookingTransport.planning.route") }}</label>
            <input type="text" v-model="idRoute"/>
            <!-- <select class="form-control" v-model="idRoute" id="routes" @change="showSetStops" disabled>
              <option value="0" disabled> {{$t('bookingTransport.select')}}</option>
              <option v-for="data in arrayRutas" :key="data.id" :value="data.id" v-text="data.route_name"></option>
            </select> -->
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.planning.route_description") }}</label>
            <input type="text" v-model="route_description"/>
          </b-col>
          <b-col sm="2">
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.platform")}}
              </label>
              <input type="number" v-model="idPlatform"/>
            </div>
          </b-col>
          <b-col sm="2" lg="2" >
            <input type="checkbox" id="enablePlanning-checkbox" v-model="EnablePlanning"/>
            <label for="enablePlanning-checkbox"> {{$t('bookingTransport.Enable')}}</label>
          </b-col>
        </b-row>
        <v-client-table :data="tableData" :columns="table_optionsCarga.columns" :options="table_optionsCarga.options" ref="PlanningStops" id="PlanningStops">
          <template #error="props"> <div  style="color:red;" v-if="props.row.error"> {{"Error"}} </div></template>
          <template #schedule="props">{{ props.row.schedule }}</template>
          <template v-slot:edit="props">
            <center>
              <i style='font-size:24px' class='fas btn-outline-secondary' @click="ModifyStops(props.row,false)">&#xf044;</i>
            </center>
          </template>
          <template v-slot:remove="props">
            <center>
              <i style='font-size:24px' class='fas btn-outline-secondary' @click="ModifyStops(props.row,true)">&#xf1f8;</i>
            </center>
          </template>
          <button
            class="btn-AddStops btn-outline-secondary"
            slot="beforeLimit"
            type="primary"
            @click="AddRoutes">
            {{$t('bookingTransport.Routes.AddStop')}}
          </button>
        </v-client-table>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirmPrePlanning()">
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEditPrePlanning()">
            {{ $t("bookingTransport.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" centered ref="my-information" no-close-on-backdrop tabindex="-1" >
      <template #modal-header>
        <h3>
          <p class="labelBold float-left">{{ $t("bookingTransport.information") }}</p>
        </h3>
      </template>
      <b-container class="bv-example-row">

        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="4">
            <!-- <label class="labelBold">{{ $t("bookingTransport.planning.schedule") }}</label> -->
            <label class="labelBold">{{ $t("bookingTransport.routesCreate") }}</label>
            <input type="text" v-model="PrePlanningCreate" disabled/>
          </b-col>
          <b-col sm="4">
            <!-- <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_time") }}</label> -->
            <label class="black">{{ $t("bookingTransport.routesNoCreate") }}</label>
            <input type="text" v-model="PrePlanningError" disabled/>
          </b-col>
        </b-row>
        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <!-- <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_time") }}</label> -->
            <label class="black">{{ $t("bookingTransport.routesCreate") }}</label>
            <input type="text" v-model="RutasCreadas" disabled/>
          </b-col>

        </b-row>







      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="CloseInformation()"
          >
            {{ $t("bookingTransport.acept") }}
          </b-button>

        </div>
      </template>
    </b-modal>


    <b-modal style="z-index:1" size="lg" centered ref="my-cancellation" no-close-on-backdrop  :title="$t('bookingTransport.Continue')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100">
          <h1>
            <p class="labelBold float-left">{{$t('bookingTransport.Continue')}}</p>
          </h1>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <div class="error-msg">
              <h2>{{$t("bookingTransport.planning.Total")}} {{this.arrayCancellation.length}}</h2>
            </div>
          </b-col>
        </b-row>

        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <h3>{{$t("bookingTransport.planning.CancellationMessage")}}</h3>

            <!-- <textarea v-model="error" class="form-control" rows="15">

              </textarea> -->

          </b-col>
          <br/>


        </b-row>

      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditMyCancellation()"
          >
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeMyCancellation()"
          >
            {{ $t("bookingTransport.cancel") }}
          </b-button>

        </div>
      </template>
    </b-modal>

    <b-modal size="lg" centered ref="my-info"  scrollable :title="$t('bookingTransport.infoCsv')" tabindex="-1" >
      <div v-if="appLang =='es'">
        <p>
          Archivo en formato .csv
          <br/>
          Nombre de columnas: route_idE,route_description,period_from_DDMMYYY,period_to_DDMMYYY,idPlatform,blockedSeats,capacity,shift,route_id,Descripcion_Ruta,Id_Parada,Descripcion_Parada,coordenates(separadas por ";", ejemplo -98.0000;45.000),schedule,.
          <br/>
        </p>
      </div>
      <div v-if="appLang =='en'">
        File in .csv format
        <br/>
        Column name: route_idE,route_description,period_from_DDMMYYY,period_to_DDMMYYY,idPlatform,blockedSeats,capacity,shift,route_id,Descripcion_Ruta,Id_Parada,Descripcion_Parada,coordenates(separated by ";", example -98.0000;45.000),schedule,.
        <br/>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right btn-xl"
            @click="DowloadLayout()"
          >
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>


    <b-modal style="z-index:1" size="xl" centered ref="my-cancellation-massive" no-close-on-backdrop  :title="$t('bookingTransport.Continue')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100">
          <h1>
            <p class="labelBold float-left">{{$t('bookingTransport.Continue')}}</p>
          </h1>
        </div>
      </template>
      <b-container class="bv-example-row">
        <!-- <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
        <b-col sm="12">
          <div class="error-msg">
            <h2>{{$t("bookingTransport.planning.Total")}} {{this.arrayCancellation.length}}</h2>
          </div>
        </b-col>
        </b-row> -->

        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <div class="error-msg">
              <h3>{{$t("bookingTransport.planning.CancellationMessageMassive")}}</h3>
            </div>
            <!-- <textarea v-model="error" class="form-control" rows="15">
              </textarea> -->

          </b-col>

          <b-col sm="12">
            <v-client-table :data="arrayCancelationMassive" :columns="table_optionsAddCancelation.columns" :options="table_optionsAddCancelation.options" ref="AddCancelationMassive" id="AddCancelationMassive">
              <template #created_at="props">{{props.row.created_at | formatDateOnly(appLang)}}</template>
              <template #period_from="props">{{props.row.period_from | formatDateOnly(appLang)}}</template>
              <template #period_to="props">{{props.row.period_to | formatDateOnly(appLang)}}</template>
              <template #reservation="props"> <div class="error-msg"> <h3>{{props.row.reservation}}</h3></div> </template>
              <template #route_id="props">{{ translateRoute(props.row.route_id)}} </template>
              <template #shift="props">{{ translateShift(props.row.shift)}} </template>
              <!-- <div slot="filter__route_id">
              <select class="form-control" name="route_id" id ="route_id" v-model="selected" @change="filterStatusP(selected)">
              <option value="0">Seleccione</option>
              <option v-for="option in arrayRutas"
              v-bind:key="option.id"
              v-bind:value="option.id">
              {{option.route_name }}
              </option>
              </select>
              </div>

              <div slot="filter__shift">
              <select class="form-control" name="shift" id ="shift" v-model="selectedIdTurno" @change="filterShiftP(selectedIdTurno)">
              <option value="0">Seleccione</option>
              <option v-for="option in arraySchedule"
              v-bind:key="option.id"
              v-bind:value="option.id">
              {{option.shift_name }}
              </option>
              </select>
              </div> -->

              <div slot="filter__created_at">
                <date-picker  id="created_at" name="created_at" @change="filterCreate(Filter_created_at)"  v-model="Filter_created_at"
                              placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
                </date-picker>
              </div>
              <div slot="filter__period_from">
                <date-picker  id="period_from" name="period_from" @change="filterFrom(Filter_period_from)"  v-model="Filter_period_from"
                              placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
                </date-picker>
              </div>
              <div slot="filter__period_to">
                <date-picker  id="period_to" name="period_to" @change="filterTo(Filter_period_to)"  v-model="Filter_period_to"
                              placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
                </date-picker>
              </div>

              <template v-slot:enabled="props">
                <input
                  disabled
                  type="checkbox"
                  :name="`select${props.row.id}`"
                  :id="`select${props.row.id}`"
                  :value="props.row.id"
                  v-model="props.row.enabled"
                />
              </template>




            </v-client-table>
          </b-col>
        </b-row>

      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirmMassiveCancelation()"
          >
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeMyCancellationMassive()"
          >
            {{ $t("bookingTransport.cancel") }}
          </b-button>

        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
const ids = (value) => value != 0 && value > 0 ;
//  const sits_val = (value) =>  value ;

import { required, url, decimal } from "vuelidate/lib/validators";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";

import API_SERVICE from "@/lib/api/Booking.js";
import TripsVue from '../../qrAcess/Trips/Trips.vue';
//import moment from "moment";
import moment from "moment-timezone";

const api = new API_SERVICE();

export default {

  components: {
    DatePicker,
    VueTimepicker
  },


  data() {
    return {


      cargaFile:false,
      typeEdit:"",



      filters: [],
      sortOrders:{},
      parse_header:[],


      validationPlanning:false,
      validationPlanningMassive:false,



      selected:'',
      selectedIdTurno:'',
      numero:'',
      id_parada:'',
      route_id:'',
      route_description:'',
      stop_number:'',
      stop_name:'',
      coordenates:'',
      schedule:'',
      DeleteStop:false,

      Filter_created_at:"",
      Filter_period_from:"",
      Filter_period_to:"",

      FinalStops:[],
      carrito:[],

      filterRoutes: '',
      filterSchedule: '',
      filterPlatform:'',
      idRoute:0,
      idSchedule:0,
      idPlatform:0,
      arrayRutas:[],
      arrayAddRutas:[],
      arrayCancelationMassive:[],
      arraySchedule:[],
      arrayPlatform:[],
      arrayCancellation:[],
      route_descriptionStop:"",

      carritoAdd:[],
      ValidateScheduleEdit:[],
      ScheduleValidate:{
        shift_name:'',
        start_time:'',
        end_time:''
      },
      IdPlanning:0,
      //availableSeats:40,
      blockedSeats:0,
      capacity:44,

      tableData: [],
      EditPrePlanning: false,
      EnablePlanning: false,
      period: false ,
      checkmassive:false,
      ocultar:false,
      massive:false,
      PlanningGenerate:true,
      PlanningGenerateMassive:false,
      DeleteRowPreplanning:false,
      PrePlanningCreate:0,
      PrePlanningError:0,
      RutasCreadas:"",
      dates:
        {
          from: null,
          to: null,
        },
      ArrayExtraordinary:[]
    }

  },
  validations: {

    dates: {
      from:{
        required,
        InvalidDate: function(Planning) {
          // var fecha = new Date().toISOString().slice(0, 10);
          var fecha = new Date();
          var ValFecha =  moment(fecha).format('YYYY-MM-DD');
          if (Planning >= ValFecha)
          {
            return true;
          }
          else
          {
            return false;
          }

        }
      },
      to: {
        required
      }
    },
    idSchedule:{
      ids
    },
    capacity:{
      ids
    },
    // coordenates:{
    //     required,
    //      coord: function(coordinates) {
    //       if (!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
    //           return false;
    //       }
    //           const [latitude, longitude]= coordinates.split(",");
    //           return (latitude>-90 && latitude<90 && longitude>-180 && longitude<180);
    //       }
    //   },
    // availableSeats:{
    // sits_val: function(value) {
    // console.log(value <= this.capacity);
    // console.log(value >= this.capacity);
    // if (value <= this.capacity)
    //return true;
    //if (value >= this.capacity)
    // return false;
    //},
    //},
    availableSeats:{

      sits_val: function(value) {
        // console.log(value <= this.capacity);
        // console.log(value >= this.capacity);
        if (Math.floor(value) <= Math.floor(this.capacity))
          return true;
        if (Math.floor(value) >=   Math.floor(this.capacity))
          return false;
      },
    },

    blockedSeats:{
      sits_val: function(value) {
        // console.log(value <= this.capacity);
        // console.log(value >= this.capacity);
        if (Math.floor(value) <= Math.floor(this.capacity))
          return true;
        if (Math.floor(value) >= Math.floor(this.capacity))
          return false;
      },
    },




  },
  beforeMount: async function() {
    this.$store.commit("global/SET_LOADING", true);
    await this.getRoutes();
    await this.getSchedule();
    this.$store.commit("global/SET_LOADING", false);
  },
  methods:{

    DowloadLayout(){

      try{
        let anchor = document.createElement("a");
        anchor.href = "https://817467424320-amap-dbs-qa-app-files.s3.ca-central-1.amazonaws.com/Booking/Extraordinary/ExtraordinaryconUTF8.csv";

        anchor.target = "_blank";
        anchor.click();

        this.$refs['my-info'].hide();
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.dowloaded"),
          show: true,
          type: "success"});

      }
      catch(error){
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },


    showInf: function(){
      this.$refs['my-info'].show();
    },

    closeMyCancellationMassive()
    {
      //console.log("valida");
      this.EditPrePlanning = false;
      this.idRoute = 0;
      this.availableSeats = 40;
      //this.blockedSeats = 44;
      this.capacity = 44;
      this.idSchedule = 0;
      this.idPlatform = 0;
      this.dates.from = "";
      this.dates.to = "";
      this.tableData = [];
      this.arrayCancelationMassive = [];
      this.$refs['my-cancellation-massive'].hide();

    },


    EditConfirmMassiveCancelation: async function(){
      try{
        this.$store.commit("global/SET_LOADING", true);
        const pos = this.ArrayExtraordinary.map(e => e.route_id).indexOf(this.idRoute);

        if(this.validationPlanning == true)
        {
          // console.log(this.arrayCancelationMassive);
          // return;
          console.log("Entra1");
          const queries = {};
          queries.action = "create"
          queries.query= {
            route_type: "extraordinary",
            route_id:this.idRoute,
            route_description: this.route_description,
            blockedSeats:this.blockedSeats,//Libres
            availableSeats:this.availableSeats,//Asientos bloqueados
            capacity:this.capacity,//Capacidad
            shift:this.idSchedule,
            platforms_ids:[this.idPlatform],
            period_from:this.dates.from,
            period_to:this.dates.to,
            stops_ids:this.FinalStops
          };

          const resp = await api.Planning(queries);
          // CREACION PLANEACION
          console.log(queries);
          this.EditPrePlanning = false;
          this.idRoute = 0;
          this.availableSeats = 40;
          // this.blockedSeats = 44;
          this.capacity = 44;
          this.idSchedule = 0;
          this.idPlatform = 0;
          this.dates.from = "";
          this.dates.to = "";
          this.tableData = [];
          this.UpdateplanningTable();

          for await(const data of this.arrayCancelationMassive) {

            if(data.usersCancelation.length>0)
            {
              //var ValidateRuta = this.arrayRutas.filter((e)=> e.id == data.route_id);
              //var period_from = moment(data.period_from).format('YYYY-MM-DD');
              //var period_from = moment.tz(data.period_from,"America/Mexico_City").format("YYYY-MM-DD")
              var period_from = moment(data.period_from).utc().format('YYYY-MM-DD')

              const queries = {
                type: "BookingCancellation",
                priority: "booking",
                controlNumbers: data.usersCancelation,
                // this.arrayCancellation
                title: "Reservación Cancelada",
                subtitle:  "Modificación de ruta " + data.route_description,
                cover: null,
                body: {
                  ops: [
                    {
                      // insert: "Se realizo la cancelación para tu reservación: RUTA.  \n  Fecha : " + this.dates.from + "Para la ruta  :" + ValidateRuta[0].route_name
                      //insert: "La reservación para : \n"+ data.route_description + "\n el día : " + period_from + " ha sido cancelada."
                      //insert: "Lamentamos informarte que tu reserva para :\n"+ data.route_description + "\n del día: " + period_from + " ha sido cancelada por Servicios de Movilidad debido a una suspensión temporal en los servicios de transporte ofrecidos para ese día."
                      insert: "Modificación de ruta " + data.route_description + "\nTe informamos que la ruta "+ data.route_description + " del día " + period_from + " ha sido modificada por Servicios de Movilidad, por tal motivo tu reserva ha sido cancelada. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                    }
                  ]
                },
                author: "Audi México"
              };
              const notifix = await api.postNotif(queries);

              this.ArrayExtraordinary.splice(pos,1);
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("bookingTransport.planning.deleteSuccess")}`,
                show: true,
                type: "success"
              });


            }

          }

          this.validationPlanning = false;
          this.arrayCancelationMassive = [];
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.planning.planingCreate") + this.route_description,
            show: true,
            type: "success"
          });

        }
        if(this.validationPlanningMassive == true)
        {
          // console.log(this.arrayCancelationMassive);
          // return;
          console.log("Entra2")
          const queries = {};
          queries.action = "create"
          queries.query= {
            route_type: "extraordinary",
            route_id:this.idRoute,
            route_description: this.route_description,
            blockedSeats:this.blockedSeats,//Libres
            availableSeats:this.availableSeats,//Asientos bloqueados
            capacity:this.capacity,//Capacidad
            shift:this.idSchedule,
            platforms_ids:[this.idPlatform],
            period_from:this.dates.from,
            period_to:this.dates.to,
            stops_ids:this.FinalStops
          };
          const resp = await api.Planning(queries);
          // CREACION PLANEACION
          console.log(resp);
          this.EditPrePlanning = false;
          this.idRoute = 0;
          this.availableSeats = 40;
          // this.blockedSeats = 44;
          this.capacity = 44;
          this.idSchedule = 0;
          this.idPlatform = 0;
          this.dates.from = "";
          this.dates.to = "";
          this.tableData = [];
          this.UpdateplanningTable();

          if(resp.message =="Los datos fueron creados correctamente.") {

            for await(const data of this.arrayCancelationMassive) {

              if (data.usersCancelation.length > 0) {
                // var ValidateRuta = this.arrayRutas.filter((e)=> e.id == data.route_id);
                //var period_from = moment(data.period_from).format('YYYY-MM-DD');
                //var period_from = moment.tz(data.period_from,"America/Mexico_City").format("YYYY-MM-DD")
                var period_from = moment(data.period_from).utc().format('YYYY-MM-DD')
                const queries = {
                  type: "BookingCancellation",
                  priority: "booking",
                  controlNumbers: data.usersCancelation,
                  // this.arrayCancellation
                  title: "Reservación Cancelada",
                  subtitle: "Modificación de ruta " + data.route_description,
                  cover: null,
                  body: {
                    ops: [
                      {
                        //insert: "Se realizo la cancelación para tu reservación: RUTA.  \n  Fecha : " + this.dates.from + "Para la ruta  :" + ValidateRuta[0].route_name
                        //insert: "La reservación para : \n" + data.route_description + "\n el día : " + period_from + " ha sido cancelada."
                        //insert: "Lamentamos informarte que tu reserva para:: \n" + data.route_description + "\n del día : " + period_from + " ha sido cancelada por Servicios de Movilidad debido a ajustes en la planeación de servicios para ese día. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                        insert: "Modificación de ruta " + data.route_description +"\nTe informamos que la ruta " + data.route_description + " del día " + period_from + " ha sido modificada por Servicios de Movilidad, por tal motivo tu reserva ha sido cancelada. Por favor revisa en el apartado de transporte las nuevas rutas programadas."

                      }
                    ]
                  },
                  author: "Audi México"
                };
                const notifix = await api.postNotif(queries);
              }
            }
          }


          console.log(pos);
          this.ArrayExtraordinary.splice(pos,1);
          this.arrayCancelationMassive = [];
          this.UpdateplanningTable();
          this.$refs['my-cancellation-massive'].hide();
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.planning.planingCreate") + this.route_description,
            show: true,
            type: "success"
          });
          return;

        }
        else{

          for await( const data of this.arrayCancelationMassive ) {

            console.log("Entra3")

            console.log(data);

            const queries = {};
            queries.action = "update"
            queries.query= {
              route_type: "extraordinary",
              id:data.id,
              enabled: false,
              route_id: data.route_id,
              route_description: data.route_description,
              blockedSeats: data.blockedSeats,
              availableSeats: data.availableSeats,
              capacity: data.capacity,
              shift: data.shift,
              platforms_ids: data.platforms_ids,
              period_from: data.period_from,
              period_to: data.period_to,
              stops_ids: data.stops_ids

            };

            const respx = await api.Planning(queries);


            console.log(respx);
            if(respx.message =="Los datos fueron actualizados correctamente.")
            {

              if(data.usersCancelation.length>0)

              {
                //var ValidateRuta = this.arrayRutas.filter((e)=> e.id == data.route_id);
                //var period_from = moment(data.period_from).format('YYYY-MM-DD');
                //var period_from = moment.tz(data.period_from,"America/Mexico_City").format("YYYY-MM-DD")
                var period_from = moment(data.period_from).utc().format('YYYY-MM-DD')

                const queries = {
                  type: "BookingCancellation",
                  priority: "booking",
                  controlNumbers: data.usersCancelation,
                  // this.arrayCancellation
                  title: "Reservación Cancelada",
                  subtitle: "Suspensión temporal de servicios de transporte",// data.route_description,
                  cover: null,
                  body: {
                    ops: [
                      {
                        // insert: "Se realizo la cancelación para tu reservación: RUTA.  \n  Fecha : " + this.dates.from + "Para la ruta  :" + ValidateRuta[0].route_name
                        //insert: "La reservación para : "+ data.route_description + " el día :" + period_from + " ha sido cancelada."
                        //insert: "Lamentamos informarte que tu reserva para :: "+ data.route_description + " del día :" + period_from + " ha sido cancelada por Servicios de Movilidad debido a una suspensión temporal en los servicios de transporte ofrecidos para ese día."
                        insert: "Suspensión temporal de servicios de transporte \nLamentamos informarte que tu reserva para " + data.route_description + " del día " + period_from + " ha sido cancelada por Servicios de Movilidad debido a una suspensión temporal en los servicios de transporte ofrecidos para ese día. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                      }
                    ]
                  },
                  author: "Audi México"
                };
                const notifix = await api.postNotif(queries);

              }
            }
          }
        }
        this.UpdateplanningTable();
        this.$refs['my-cancellation-massive'].hide();
        this.$store.commit("global/SET_LOADING", false);
      }



      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },


    EditMyCancellation()
    {
      this.$refs['my-cancellation'].hide();

    },

    closeMyCancellation(){
      this.EditPrePlanning = false;
      this.idRoute = 0;
      //this.availableSeats = 40;
      this.blockedSeats = 0;
      this.capacity = 44;
      this.idSchedule = 0;
      this.idPlatform = 0;
      this.dates.from = "";
      this.dates.to = "";
      this.tableData = [];

      this.$refs['Pre-Planning-edit'].hide();
      this.$refs['my-cancellation'].hide();

    },

    removeFile: function () {
      try{
        this.cargaFile = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.delete"),
          show: true,
          type: "success"
        });
      }
      catch(error){

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: "Hubo un error al cargar el archivo, inténtalo de nuevo más tarde.",
          show: true,
          type: "error"
        });

      }
    },




    closeEdit(){
      this.$refs['my-edit'].hide();
    },

    CancelationMassive: async function() {

      try {

        this.$store.commit("global/SET_LOADING", true);
        this.arrayCancelationMassive = [];
        for await(const data of this.carrito) {

          const queries = {};
          queries.planningId = data.id; //73;
          const resp = await api.Cancellation(queries);

          var json = {
            id: data.id,
            reservation: resp.data.length,
            route_id: data.route_id,
            stops_ids: data.stops_ids,
            platforms_ids: data.platformsIds,
            availableSeats: data.availableSeats,
            blockedSeats: data.blockedSeats,
            shift: data.shift,
            period_from: data.period_from,
            period_to: data.period_to,
            enabled: false,
            created_at: data.created_at,
            route_description: data.route_description,
            capacity: data.capacity,
            usersCancelation: resp.data
          };
          this.arrayCancelationMassive.push(json)
        }
        this.$refs['my-cancellation-massive'].show();
        this.$store.commit("global/SET_LOADING", false);

      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    closeAddRoute(){
      this.carrito=[];
      this.carritoAdd=[];
      this.$refs['add-Stops'].hide();
    },

    EditAddConfirm(){



      try{
        this.$store.commit("global/SET_LOADING", true);

        this.carrito.forEach((data)=>{

          var queries = {};
          queries.route_id = data.route_id
          queries.route_description = data.route_description
          queries.id = data.id
          queries.stop_description = data.stop_name
          queries.coordenates = data.coordenates

          if (data.schedule == null)
          {
            queries.schedule = "Ninguno"
          }
          else if (data.schedule != null)
          {
            queries.schedule = data.schedule
            if(queries.schedule == undefined){
              queries.schedule = "Ninguno"
            }else{
              queries.schedule = data.schedule
            }
          }

          if(queries.schedule.length>=4 && queries.schedule.length<5){
            queries.schedule = "0"+ queries.schedule;
          }

          ///////////////////////////////////

          if(queries.schedule !="Ninguno" && queries.schedule != null){
            if(queries.schedule+":00" >= this.ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)
            {
              queries.error = false;

            }
            else if(this.ValidateScheduleEdit[0].end_time <= this.ValidateScheduleEdit[0].start_time){

              if((queries.schedule+":00"  >= this.ValidateScheduleEdit[0].start_time)||(queries.schedule+":00" >= '00:00' && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)){
                queries.error = false;
              }
              else{
                queries.error = true;
              }
            }
            else{
              queries.error = true;
            }
          }
          else if(queries.schedule != null) {
            queries.error = true;
          }
          this.tableData.push(queries)

        });
        var organize =  this.tableData;

        this.tableData =  organize.sort(function (a, b) {
          var x = a['schedule'],
            y = b['schedule'];
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.planning.addedStops") + this.carrito.length ,
          show: true,
          type: "success"
        });
        this.carrito=[];
        this.carritoAdd=[];
        this.$refs['add-Stops'].hide();

      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    async AddChkStop(Data,cb)
    {
      try
      {
        if(cb.target.checked)
        {
          const json = {
            id:Data.id,
            stop_name:Data.stop_name,
            route_id:Data.route_id,
            route_description:Data.route_description,
            coordenates:Data.coordenates,
            schedule:Data.schedule
          }
          this.carrito.push(json);
          // console.log(this.carrito);
        }
        else{
          this.carrito = this.carrito.filter((e)=> e.id !== Data.id)
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },



    EditConfirmPrePlanning: async function(){
      try{
        var fecha = new Date();
        var Now=  moment(fecha).format('YYYY-MM-DD');
        if(this.dates.from < Now){
          this.dates.from = Now;
        }

        this.$store.commit("global/SET_LOADING", true);
        // const pos = this.ArrayExtraordinary.map(e => e.route_id).indexOf(this.idRoute);
        var route = this.idRoute;
        var idSchedule = this.idSchedule;
        const pos = this.ArrayExtraordinary.findIndex(function (e) { return e.route_id === route && e.shift === idSchedule });
        if(this.DeleteRowPreplanning){
          this.ArrayExtraordinary.splice(pos,1);
          this.$store.commit("global/SET_LOADING", false);
          this.$refs['Pre-Planning-edit'].hide();
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.deleteSuccess")}`,
            show: true,
            type: "success"
          });
        }
        else{
          this.$v.$touch();
          if(this.$v.$error){
            this.$store.commit("global/SET_LOADING", false);
            return;
          }
          if(this.dates.to < this.dates.from )
          {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("mobilityOnDemand.rango")}`,
              show: true,
              type: "error"
            });
            return;
          }
          if(this.tableData.length == 0)  {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: this.$t("bookingTransport.planning.addStops"),
              show: true,
              type: "error" });
            return;
          }
          if(this.idPlatform == 0)  {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: this.$t("bookingTransport.planning.addPlatform"),
              show: true,
              type: "error" });
            return;
          }


          if(this.EditPrePlanning == "EditExtraordinary")
          {




            const queriesValPlatform = {};
            queriesValPlatform.action = "validation_platform"
            queriesValPlatform.query = {
              period_from: this.dates.from,
              period_to: this.dates.to,
              platform_id: this.idPlatform,
              shift_id: this.idSchedule
            };

            const validatePlatform = await api.ValPlatform(queriesValPlatform);


            if(validatePlatform.data.data.length > 0) {

              const pos = validatePlatform.data.data.map(e => e.route_id).indexOf(this.idRoute);

              console.log(pos);
              if(pos < 0 && validatePlatform.data.data.length > 0)
              {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("bookingTransport.platformBusy")}`,
                  show: true,
                  type: "error" });
                console.log("IdRoute diferente")
                return;
              }

              var arr1 = validatePlatform.data.data.map(e => e.route_id);
              var filteredPlatforms= arr1.filter(function(item, pos){
                return arr1.indexOf(item)== pos;
              });
              //console.log(filteredPlatforms);
              if(pos >=0 && filteredPlatforms.length > 1)
                //if(pos >=0 && validatePlatform.data.data.length > 1)
              {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  //msg: `${this.$t("bookingTransport.platformBusy")}`,
                  msg: "Andén ocupado por diversas rutas",
                  show: true,
                  type: "error" });
                console.log("IdRoute diferente pero mas planeaciones")
                return;
              }

            }



            var ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
            const paradas = [];
            this.tableData.forEach((data) => {
              var queries = {};
              queries.route_id = data.route_id;
              queries.route_description = data.route_description;
              queries.id = data.id
              queries.stop_description = data.stop_description
              queries.coordenates = data.coordenates
              queries.schedule = data.time
              if (data.schedule == null)
              {
                queries.schedule = "Ninguno"
              }
              else if (data.schedule != null)
              {
                queries.schedule = data.schedule
                if(queries.schedule == undefined){
                  queries.schedule = "Ninguno"
                }else{
                  queries.schedule = data.schedule
                }
              }
              if(queries.schedule.length>=4 && queries.schedule.length<5){
                queries.schedule = "0"+ queries.schedule;
              }
              if(queries.schedule !="Ninguno" && queries.schedule != null){
                if(queries.schedule+":00"  >= ValidateScheduleEdit[0].start_time && queries.schedule+":00"  <= ValidateScheduleEdit[0].end_time)
                {
                  queries.error = false;
                }
                else if(ValidateScheduleEdit[0].end_time <= ValidateScheduleEdit[0].start_time){
                  if((queries.schedule+":00"   >= ValidateScheduleEdit[0].start_time)||(queries.schedule+":00"  >= '00:00' && queries.schedule+":00"  <= ValidateScheduleEdit[0].end_time)){
                    queries.error = false;
                  }
                  else{
                    queries.error = true;
                  }
                }
                else{
                  queries.error = true;
                }
              }
              else if(queries.schedule != null) {
                queries.error = true;
              }
              paradas.push(queries);
            });
            this.tableData = paradas;
            this.FinalStops = [];
            var Errores = 0;
            this.tableData.forEach((data) => {if(data.error) {Errores++;} });
            if(Errores>0)
            {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: this.$t("bookingTransport.planning.stopError") + Errores,
                show: true,
                type: "error" });
              return;
            }
            else if(Errores==0)
            {
              var organize =  this.tableData;
              this.tableData =  organize.sort(function (a, b) {
                var x = a['schedule'],
                  y = b['schedule'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
              });
              this.tableData.forEach((data, index) => {
                var json = {
                  stop_id:data.id,
                  stop_description: data.stop_description,
                  route_id:data.route_id,
                  route_description:data.route_description,
                  stop_coordenates:data.coordenates,
                  time:data.schedule
                };
                this.FinalStops.push(json)
              });

              const queries = {};
              queries.action = "update"
              queries.query= {
                route_type: "extraordinary",
                id:this.IdPlanning,
                enabled:this.EnablePlanning,
                route_id:this.idRoute,
                route_description: this.route_description,
                blockedSeats:this.blockedSeats,//Libres
                availableSeats:this.availableSeats,//Asientos bloqueados
                capacity:this.capacity,//Capacidad
                shift:this.idSchedule,
                platforms_ids:[this.idPlatform],
                period_from:this.dates.from,
                period_to:this.dates.to,
                stops_ids:this.FinalStops
              };
              const resp = await api.Planning(queries);
              if(resp.message =="Los datos fueron actualizados correctamente.")
              {
                if(this.arrayCancellation.length>0)
                {
                  //var ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
                  //var period_from = moment(this.dates.from).format('YYYY-MM-DD');
                  //var period_to = moment(this.dates.to ).format('YYYY-MM-DD');
                  //var period_from = moment.tz(this.dates.from,"America/Mexico_City").format("YYYY-MM-DD")
                  //var period_to = moment.tz(this.dates.to,"America/Mexico_City").format("YYYY-MM-DD")
                  var period_from = moment(this.dates.from).utc().format('YYYY-MM-DD')
                  var period_to = moment(this.dates.to).utc().format('YYYY-MM-DD')
                  const queries = {
                    type: "BookingCancellation",
                    priority: "booking",
                    controlNumbers: this.arrayCancellation,
                    // this.arrayCancellation
                    title: "Reservación Cancelada",
                    subtitle: "Modificación de ruta" + this.route_description,
                    cover: null,
                    body: {
                      ops: [
                        {
                          // insert: "Se realizo la cancelación para tu reservación: RUTA.  \n  Fecha : " + this.dates.from + "Para la ruta  :" + ValidateRuta[0].route_name
                          // insert: "La reservación para : \n"+ this.route_description + "\n para el periodo : " + period_from + " al " + period_to + " ha sido cancelada."
                          //insert: "Lamentamos informarte que tu reserva para: \n"+ this.route_description + "\n del día : " + period_from + " ha sido cancelada por Servicios de Movilidad debido a ajustes en la planeación de servicios para ese día. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                          insert: "Modificación de ruta" + this.route_description+ "\nLamentamos informarte que la planeación de la ruta "+ this.route_description+ " del periodo " + period_from + " al " + period_to+ " ha sido modificada por Servicios de Movilidad debido a ajustes en la planeación de servicios para este periodo, por tal motivo tu reserva ha sido cancelada. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                        }
                      ]
                    },
                    author: "Audi México"
                  };
                  const notifix = await api.postNotif(queries);
                }
                this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
                  show: true,
                  type: "success"
                });

                this.EditPrePlanning = false;
                this.IdPlanning = 0;
                this.idRoute = 0;
                this.route_description = "";
                this.availableSeats = 40;
                this.capacity = 44;
                this.idSchedule = 0;
                this.idPlatform = 0;
                this.dates.from = "";
                this.dates.to = "";
                this.tableData = [];
                this.UpdateplanningTable();
                this.$refs['Pre-Planning-edit'].hide();
                this.$store.commit("global/SET_LOADING", false);
                this.$v.$reset();

              }
              else
              {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  msg: resp.message,
                  show: true,
                  type: "error"
                });

              }

            }

          }

          if(this.EditPrePlanning == "EditExtraordinaryMassive"){

            const queriesValPlatform = {};
            queriesValPlatform.action = "validation_platform"
            queriesValPlatform.query = {
              period_from: this.dates.from,
              period_to: this.dates.to,
              platform_id: this.idPlatform,
              shift_id: this.idSchedule
            };

            const validatePlatform = await api.ValPlatform(queriesValPlatform);

            if(validatePlatform.data.data.length > 0) {

              const pos = validatePlatform.data.data.map(e => e.route_id).indexOf(this.idRoute);

              console.log(pos);
              if(pos < 0 && validatePlatform.data.data.length > 0)
              {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("bookingTransport.platformBusy")}`,
                  show: true,
                  type: "error" });
                console.log("IdRoute diferente")
                return;
              }

              var arr1 = validatePlatform.data.data.map(e => e.route_id);
              var filteredPlatforms= arr1.filter(function(item, pos){
                return arr1.indexOf(item)== pos;
              });
              //console.log(filteredPlatforms);
              if(pos >=0 && filteredPlatforms.length > 1)
                //if(pos >=0 && validatePlatform.data.data.length > 1)
              {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  //msg: `${this.$t("bookingTransport.platformBusy")}`,
                  msg: "Andén ocupado por diversas rutas",
                  show: true,
                  type: "error" });
                console.log("IdRoute diferente pero mas planeaciones")
                return;
              }

            }

            var Stops = [];
            var errorStop = false;
            var IdsError = "";
            var ValidateScheduleEdit = this.arraySchedule.filter((e)=> e.id == this.idSchedule);

            console.log(ValidateScheduleEdit[0].end_time)

            this.tableData.forEach((data, index) => {
              var queries = {};
              queries.route_id = data.route_id
              queries.route_description = data.route_description
              queries.id = data.id
              queries.stop_description = data.stop_description


              if (data.schedule == null)
              {
                queries.schedule = "Ninguno"
              }
              else if (data.schedule != null)
              {
                queries.schedule = data.schedule
                if(queries.schedule == undefined){
                  queries.schedule = "Ninguno"
                }else{
                  queries.schedule = data.schedule
                }
              }

              if(queries.schedule.length>=4 && queries.schedule.length<5){
                queries.schedule = "0"+ queries.schedule;
                // console.log("Entra")
              }
              // console.log(queries.schedule.length);
              // console.log(queries.schedule);
              if(queries.schedule !="Ninguno" && queries.schedule != null){

                if(queries.schedule+":00"  >= ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= ValidateScheduleEdit[0].end_time)
                {

                  queries.error = false;
                }
                else if(ValidateScheduleEdit[0].end_time <= ValidateScheduleEdit[0].start_time){
                  if((queries.schedule+":00"  >= ValidateScheduleEdit[0].start_time)||(queries.schedule +":00">= '00:00' && queries.schedule+":00" <= ValidateScheduleEdit[0].end_time)){

                    queries.error = false;

                  }
                  else{
                    errorStop = true;
                    queries.error = true;
                    // PrePlanning.ErrorSchedule = true;
                    IdsError = IdsError + "," + queries.id;
                    // IdsError.push(queries.id);
                  }
                }
                else{
                  errorStop = true;
                  queries.error = true;
                  // PrePlanning.ErrorSchedule = true;
                  IdsError = IdsError + "," + queries.id
                  // IdsError.push(queries.id);
                }
              }

              else if(queries.schedule != null) {
                errorStop = true;
                queries.error = true;
                //PrePlanning.ErrorSchedule = true;
                // IdsError.push(queries.id)
                IdsError = IdsError + "," + queries.id
              }



              const coordinates = data.coordenates.replace(';', ',');
              const [latitude, longitude]= coordinates.split(",");
              const valCoor = latitude>-90 && latitude<90 && longitude>-180 && longitude<180;
              //console.log(!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/));
              //console.log(valCoor)

              queries.coordenates = coordinates;

              if (!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
                errorStop = true;
                queries.error = true;
                IdsError = IdsError + ",Coordenadas:" + queries.id
              }
              else{
                if(!valCoor){
                  //querieStop.coordenates = coordinates;
                  errorStop = true;
                  queries.error = true;
                  IdsError = IdsError + ",Coordenadas:" + queries.id
                }
              }
              Stops.push(queries);
            });


            this.tableData = Stops;
            this.FinalStops = [];
            var Errores = 0;
            this.tableData.forEach((data) => {if(data.error) {Errores++;} });
            if(Errores>0)
            {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: this.$t("bookingTransport.planning.stopError") + Errores,
                show: true,
                type: "error" });
              return;
            }
            else if(Errores==0)
            {

              this.tableData =  Stops.sort(function (a, b) {
                var x = a['schedule'],
                  y = b['schedule'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));});

              if(this.tableData.length == 0)
              {
                errorStop = true;
                IdsError = "Error: Horarios"
              }

              console.log(IdsError);
              //console.log(pos);
              //console.log(this.tableData);
              this.ArrayExtraordinary.splice(pos,1,{
                error: errorStop,
                IdsError:IdsError,
                period_from:this.dates.from,
                period_to:this.dates.to,
                blockedSeats:this.blockedSeats,
                availableSeats:this.availableSeats,
                capacity:this.capacity,
                shift:this.idSchedule,
                route_id:this.idRoute,
                route_description:this.route_description,
                platformsIds:this.idPlatform,
                stops_ids:this.tableData
              });
              console.log(this.ArrayExtraordinary);
              this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
                show: true,
                type: "success"
              });
              this.EditPrePlanning = false;
              this.IdPlanning = 0;
              this.idRoute = 0;
              this.route_description = "";
              this.availableSeats = 40;
              this.capacity = 44;
              this.idSchedule = 0;
              this.idPlatform = 0;
              this.dates.from = "";
              this.dates.to = "";
              this.tableData = [];
              this.$refs['Pre-Planning-edit'].hide();
              this.$store.commit("global/SET_LOADING", false);
              this.$v.$reset();
            }
          }
        }
      }

      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    CloseInformation(){
      this.UpdateplanningTable();
      this.$refs['my-information'].hide();
    },

    UpdateplanningTable: function() {
      this.planningTable.refresh();
    },



    SavePrePlanning: async function () {
      try{
        this.$store.commit("global/SET_LOADING", true);
        this.PrePlanningCreate = 0;
        this.PrePlanningError = 0;
        this.RutasCreadas  = "";
        console.log(this.ArrayExtraordinary)

        //for ( const data of this.ArrayExtraordinary ) {
        await this.ArrayExtraordinary.forEach(async(data,index) =>  {
          var FinalStops = [];
          data.stops_ids.forEach((xdata, index) => {
            var json = {

              route_id:xdata.route_id,
              route_description:xdata.route_description,
              stop_id:xdata.id,
              stop_description:xdata.stop_description,
              stop_coordenates:xdata.coordenates,
              time:xdata.schedule

            };
            FinalStops.push(json)
          });
          const queries = {};
          queries.action = "create"
          queries.query= {
            route_type: "extraordinary",
            //route_id:data.route_id,
            blockedSeats:data.blockedSeats,
            availableSeats:data.availableSeats,
            capacity:data.capacity,
            shift:data.shift,
            platforms_ids:[data.platformsIds],
            period_from:data.period_from,
            period_to:data.period_to,
            route_description:data.route_description,
            route_id:data.route_id,
            stops_ids:FinalStops,

          };

          if(data.error)
          {
            this.PrePlanningError = this.PrePlanningError + 1;
          }
          else {



            var ValPlatform = false;

            const queriesValPlatform = {};
            queriesValPlatform.action = "validation_platform"
            queriesValPlatform.query = {
              period_from: data.period_from,
              period_to: data.period_to,
              platform_id: data.platformsIds,
              shift_id: data.shift
              //route_type: "default"
            };

            const validatePlatform = await api.ValPlatform(queriesValPlatform);

            //console.log(validatePlatform);
            //console.log(validatePlatform.data.data.length);
            if(validatePlatform.data.data.length > 0) {

              const pos = validatePlatform.data.data.map(e => e.route_id).indexOf(data.route_id);
              //console.log(pos)
              if(pos < 0 && validatePlatform.data.data.length > 0)
              {
                ValPlatform = true;
                const pos = this.ArrayExtraordinary.map(e => e.route_id).indexOf(data.route_id);
                this.ArrayExtraordinary.splice(pos,1,{
                  error: true,
                  IdsError:"Andén duplicado",
                  period_from:data.period_from,
                  period_to:data.period_to,
                  route_description: data.route_description,
                  blockedSeats:data.blockedSeats,
                  availableSeats:data.availableSeats,
                  capacity:data.capacity,
                  shift:data.shift,
                  route_id:data.route_id,
                  platformsIds:data.platformsIds,
                  stops_ids:FinalStops
                });
              }

              var arr1 = validatePlatform.data.data.map(e => e.route_id);
              var filteredPlatforms= arr1.filter(function(item, pos){
                return arr1.indexOf(item)== pos;
              });
              //console.log(filteredPlatforms);
              if(pos >=0 && filteredPlatforms.length > 1)
                //if(pos >=0 && validatePlatform.data.data.length > 1)
              {
                ValPlatform = true;
                const pos = this.ArrayExtraordinary.map(e => e.route_id).indexOf(data.route_id);
                this.ArrayExtraordinary.splice(pos,1,{
                  error: true,
                  IdsError:"Andén ocupado por diversas rutas",
                  period_from:data.period_from,
                  period_to:data.period_to,
                  route_description: data.route_description,
                  blockedSeats:data.blockedSeats,
                  availableSeats:data.availableSeats,
                  capacity:data.capacity,
                  shift:data.shift,
                  route_id:data.route_id,
                  platformsIds:data.platformsIds,
                  stops_ids:FinalStops
                });
              }
            }

            if(ValPlatform){
              this.PrePlanningError = this.PrePlanningError + 1;
            }
            else{


              const queriesValidation = {};
              queriesValidation.action = "validation"
              queriesValidation.query= {
                period_from:data.period_from,
                period_to:data.period_to,
                route_id:data.route_id,
                shift:data.shift
              };


              console.log("Response Validate")
              const responseValidate = await api.ValPlanning(queriesValidation);

              if(responseValidate.data.data.length > 0)
              {
                this.idRoute = data.route_id;
                this.availableSeats =data.availableSeats;
                this.route_description = data.route_description;
                this.capacity=data.capacity;
                this.idSchedule=data.shift;
                this.idPlatform=data.platformsIds;
                this.dates.from=data.period_from;
                this.dates.to=data.period_to;
                this.FinalStops=data.stops_ids;

                this.validationPlanningMassive = true;

                const queries = {};
                queries.action = "list"
                queries.pagination= {all:false,
                  limit:25,
                  page:1
                };
                queries.filters = {
                  id: responseValidate.data.data[0].planning_id
                }
                const resPlann = await api.Planning(queries);
                //console.log("Valida Extraordinarias")
                //console.log(resPlann.data);
                var Datos = resPlann.data[0];
                // console.log(Datos.platforms_ids[0]);

                for await( const data of responseValidate.data.data) {
                  // console.log(data);
                  var json = {
                    id:Datos.id,
                    reservation:data.control_numbers.length,
                    route_id: Datos.route_id,
                    stops_ids: Datos.stops_ids,
                    platforms_ids: Datos.platformsIds[0],
                    availableSeats: Datos.availableSeats,
                    blockedSeats: Datos.blockedSeats,
                    shift: Datos.shift,
                    period_from: data.booking_date,
                    period_to: data.booking_date,
                    enabled: true,
                    created_at: Datos.created_at,
                    route_description: Datos.route_description,
                    capacity: Datos.capacity,
                    usersCancelation: data.control_numbers};
                  this.arrayCancelationMassive.push(json)
                }

                this.$refs['my-cancellation-massive'].show();
                this.$refs['my-information'].show();
                this.$store.commit("global/SET_LOADING", false);
                return;


              }

              const resp = await api.Planning(queries); // CREACION PLANEACION

              console.log(queries);
              console.log(resp);


              //console.log("Valida Creación")
              //console.log(resp.message);
              if(resp.message == "Los datos fueron creados correctamente.")

              {

                this.PrePlanningCreate =  this.PrePlanningCreate + 1;
                //const pos = this.ArrayPrePlanning.map(e => e.route_id).indexOf(data.route_id);
                const pos = this.ArrayExtraordinary.map(e => e.route_id).indexOf(data.route_id);
                //var ValidateRuta = this.arrayRutas.filter((e)=> e.id == data.route_id);
                this.RutasCreadas = this.RutasCreadas + "- " + data.route_description;
                this.ArrayExtraordinary.splice(pos,1);
              }
              //var esperarHasta = new Date().getTime() + 1000;
              //while(new Date().getTime() < esperarHasta) continue;
            }
          }
        },Promise.resolve(setTimeout(() => {
          //this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.successful"),
            show: true,
            type: "success" });

        },2000)));

        this.RutasCreadas = this.RutasCreadas.slice(1);
        this.cargaFile = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");
        this.$refs['my-information'].show();
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.routesCreate")+ this.PrePlanningCreate + "----ERRORES : "+ this.PrePlanningError,
          show: true,
          type: "success"
        });


      }
      catch(error){

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }

    },

    EditConfirm(){

      try{
        // this.$v.$touch();
        //   if(this.$v.$error)

        this.$store.commit("global/SET_LOADING", true);

        const pos = this.tableData.map(e => e.id).indexOf(this.id_parada);
        if(this.DeleteStop){
          this.tableData.splice(pos,1);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.deleteSuccess")}`,
            show: true,
            type: "success"
          });
        }


        else{

          const coordinates = this.coordenates.replace(';', ',');
          const [latitude, longitude]= coordinates.split(",");
          const valCoor = latitude>-90 && latitude<90 && longitude>-180 && longitude<180;


          if (!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.Stops.TableStops.headings.coordenatesinvalid")}`,
              show: true,
              type: "error"
            });
            this.$store.commit("global/SET_LOADING", false);
            return
          }
          else{
            if(!valCoor){
              this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("bookingTransport.Stops.TableStops.headings.coordenatesinvalid")}`,
                show: true,
                type: "error"
              });
              this.$store.commit("global/SET_LOADING", false);
              return
            }
          }

          var ValidateSchedule = [];
          ValidateSchedule = this.arraySchedule.filter((e)=> e.id == this.idSchedule);

          // this.schedule = this.schedule+":00"

          console.log(this.schedule);
          console.log(ValidateSchedule[0].start_time);

          if(this.schedule+":00" >= ValidateSchedule[0].start_time && this.schedule+":00"<= ValidateSchedule[0].end_time){

            this.$store.commit("global/SET_LOADING", false);
            this.tableData.splice(pos,1,{

              id:this.id_parada,
              route_id:this.route_id,
              stop_description:this.stop_name,
              route_description:this.route_descriptionStop,
              coordenates:this.coordenates,
              schedule:this.schedule
            });
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
              show: true,
              type: "success"
            });


            this.tableData =  this.tableData.sort(function (a, b) {
              var x = a['schedule'],
                y = b['schedule'];
              return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });

            this.$refs['my-edit'].hide();
          }
          else if(ValidateSchedule[0].end_time <= ValidateSchedule[0].start_time){

            if((this.schedule+":00" >= ValidateSchedule[0].start_time)||(this.schedule+":00">= '00:00' && this.schedule+":00" <= ValidateSchedule[0].end_time)){

              this.$store.commit("global/SET_LOADING", false);
              this.tableData.splice(pos,1,{
                id:this.id_parada,
                route_id:this.route_id,
                stop_description:this.stop_name,
                route_description:this.route_descriptionStop,
                coordenates:this.coordenates,
                schedule:this.schedule
              });
              this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
                show: true,
                type: "success"
              });


              this.tableData =  this.tableData.sort(function (a, b) {
                var x = a['schedule'],
                  y = b['schedule'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
              });
              this.$refs['my-edit'].hide();
              return;

            }
            else{
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg:  `${this.$t("bookingTransport.Nocorresponds")}`,
                show: true,
                type: "error"
              });
            }
          }
          else{
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg:  `${this.$t("bookingTransport.Nocorresponds")}`,
              show: true,
              type: "error"
            });

          }



          return;





          this.tableData.splice(pos,1,{
            numero:this.numero,
            id:this.id_parada,
            route_id:this.route_id,
            stop_number:this.stop_number,
            stop_name:this.stop_name,
            coordenates:this.coordenates,
            schedule:this.schedule
          });
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
            show: true,
            type: "success"
          });

        }

        this.$store.commit("global/SET_LOADING", false);
        this.$refs['my-edit'].hide();

      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    ModifyStops: function(data,action){
      // this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
      this.DeleteStop = action;
      this.id_parada=data.id;
      this.route_id=data.route_id;
      this.stop_name=data.stop_description;
      this.route_descriptionStop = data.route_description;
      this.coordenates=data.coordenates;
      this.schedule=data.schedule;
      this.$refs['my-edit'].show();

    },

    closeEditPrePlanning(){

      this.EditPrePlanning = false;
      this.idRoute = 0;
      this.availableSeats = 40;
      // this.blockedSeats = 44;
      this.capacity = 44;
      this.idSchedule = 0;
      this.idPlatform = 0;
      this.dates.from = "";
      this.dates.to = "";
      this.tableData = [];
      this.$refs['Pre-Planning-edit'].hide();
    },


    AddRoutes: async function () {

      if(this.idRoute == 0)  {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg:  `${this.$t("bookingTransport.selectRoute")}`,
          show: true,
          type: "error" });
        return;
      }
      this.$refs['add-Stops'].show();
      try{

        var arrayRutasPre = [];

        this.arrayAddRutas = [];
        this.$store.commit("global/SET_LOADING", true);

        const queries = {};
        queries.catalogType = "stops"
        queries.pagination= {
          all:true,
          limit:300,
          page:1};

        queries.filters = {};
        const resp = await api.getLists(queries);

        console.log(resp);

        resp.data.forEach((data, index) => {
          var queries = {};
          queries.id = data.id
          queries.route_id = data.route_id
          //queries.stop_number = data.stop_number
          queries.stop_name = data.stop_name
          queries.coordenates = data.coordenates

          const description = this.arrayRutas.filter((e)=> e.id == data.route_id)
          //  console.log(description[0].route_name);
          if(description.length>0)
          {
            queries.route_description = description[0].route_name;
          }else
          {
            queries.route_description = "N/A"
          }

          if (data.schedule == null)
          {
            queries.schedule = "Ninguno"
          }
          else if (data.schedule != null)
          {
            queries.schedule = data.schedule[this.idSchedule]
            if(queries.schedule == undefined){
              queries.schedule = "Ninguno"
            }else{
              queries.schedule = data.schedule[this.idSchedule]
            }
          }

          if(queries.schedule.length>=4 && queries.schedule.length<5){
            queries.schedule = "0"+ queries.schedule;
          }

          arrayRutasPre.push(queries);
        });

        this.tableData.forEach((data)=> {

          arrayRutasPre = arrayRutasPre.filter((e)=> e.id !== data.id) });


        this.arrayAddRutas =  arrayRutasPre.sort(function (a, b) {
          var x = a['schedule'],
            y = b['schedule'];

          return ((x < y) ? -1 : ((x > y) ? 1 : 0)); });

        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }


    },

    showSetStops: async function (index) {

      try {
        if((this.idRoute != null && this.idSchedule != null)&&(this.idRoute != 0 && this.idSchedule != 0)){
          this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          var ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          this.idPlatform =  ValidateRuta[0].platform_id;
          this.tableData = [];
          var Stops = [];
          this.$store.commit("global/SET_LOADING", true);
          const queries = {};
          queries.action = "preset"
          queries.query = {
            route_id:this.idRoute,
            enabled: true
          };
          const resp = await api.Planning(queries);
          var numero = 0;
          resp.data.forEach((data, index) => {
            // console.log('Indice: ' + index + ' Valor: ' + data);
            // console.log(data);
            var queries = {};
            queries.numero = numero++
            queries.id = data.id
            queries.route_id = data.route_id
            queries.stop_number = data.stop_number
            queries.stop_name = data.stop_name
            queries.coordenates = data.coordenates
            if (data.schedule == null)
            {
              queries.schedule = "Ninguno"
            }
            else if (data.schedule != null)
            {
              queries.schedule = data.schedule[this.idSchedule]
              if(queries.schedule == undefined){
                queries.schedule = "Ninguno"
              }else{
                queries.schedule = data.schedule[this.idSchedule]
              }
            }

            if(queries.schedule.length>=4 && queries.schedule.length<5){
              queries.schedule = "0"+ queries.schedule;
            }
            if(queries.schedule !="Ninguno" && queries.schedule != null){

              if(queries.schedule+":00" >= this.ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)
              {
                queries.error = false;
              }
              else if(this.ValidateScheduleEdit[0].end_time <= this.ValidateScheduleEdit[0].start_time){
                if((queries.schedule+":00"  >= this.ValidateScheduleEdit[0].start_time)||(queries.schedule+":00" >= '00:00' && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)){
                  queries.error = false;
                }
                else{
                  queries.error = true;
                }
              }
              else{
                queries.error = true;
              }
            }
            else if(queries.schedule != null) {
              queries.error = true;
            }

            Stops.push(queries);
          });
          this.tableData =  Stops.sort(function (a, b) {
            var x = a['schedule'],
              y = b['schedule'];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));});

          this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
          this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
          this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;

          this.$store.commit("global/SET_LOADING", false);
        }
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    getRoutes: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {};
        queries.catalogType = "routes"
        queries.pagination= {all:false,
          limit:300,
          page:1};
        queries.filters = {route_name:this.filterRoutes};
        const resp = await api.getLists(queries);
        this.arrayRutas = resp.data;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },
    getSchedule: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {};
        queries.action = "list"
        queries.pagination= {all:false,
          limit:300,
          page:1};
        queries.filters = {
          shift_name:this.filterSchedule};
        const resp = await api.getSchedule(queries);
        this.arraySchedule = resp.data;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(eror){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: eror,
          show: true,
          type: "error"
        });

      }
    },

    translateError (error) {
      //console.log(error+"ERRORES");
      if(error==true){
        return "SI";
      }
      else if(error==false){
        return "NO";
      }
    },

    translateRoute (route_id) {
      const description = this.arrayRutas.filter((e)=> e.id == route_id)
      //  console.log(description[0].route_name);

      if(description.length>0)
      {
        return description[0].route_name;
      }else
      {
        return route_id;
      }

    },
    translateShift(shift) {
      const description = this.arraySchedule.filter((e)=> e.id == shift)
      if(description.length>0)
      {
        return description[0].shift_name
      }else
      {
        return shift;
      }
    },


    filterShift: function($event)
    {
      if($event == 0){
        this.ExtraordinaryTable.setFilter({"shift":""});
      }
      else{
        this.ExtraordinaryTable.setFilter({"shift":$event});
      }

    },

    filterStatus: function($event)
    {
      if($event == 0){
        this.ExtraordinaryTable.setFilter({"route_id":""});
      }
      else{
        this.ExtraordinaryTable.setFilter({"route_id":$event});
      }
    },

    filterShiftP: function($event)
    {
      if($event == 0){
        this.selectedIdTurno = 0;
        this.ExtraordinaryTable.setFilter({"shift":""});
      }
      else{
        this.ExtraordinaryTable.setFilter({"shift":$event});
      }

    },

    filterShiftPla: function($event)
    {
      if($event == 0){
        this.selectedIdTurno = 0;
        this.planningTable.setFilter({"shift":""});
      }
      else{
        this.planningTable.setFilter({"shift":$event});
      }

    },

    filterStatusP: function($event)
    {
      if($event == 0){
        this.selected = 0;
        this.ExtraordinaryTable.setFilter({"route_id":""});
      }
      else{
        this.ExtraordinaryTable.setFilter({"route_id":$event});
      }
    },
    filterStatusPlan: function($event)
    {
      alert("filter")
      if($event == 0){
        this.selected = 0;
        this.planningTable.setFilter({"route_id":""});
      }
      else{
        this.planningTable.setFilter({"route_id":$event});
      }
    },
    filterCreate: function($event)
    {
      this.planningTable.setFilter({"created_at":$event});

    },
    filterFrom: function($event)
    {
      this.planningTable.setFilter({"period_from":$event});
    },
    filterTo: function($event)
    {
      this.planningTable.setFilter({"period_to":$event});
    },



    loadCSV(e){
      var vm = this
      if(window.FileReader){
        var reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        document.getElementById('filecsv').textContent = e.target.files[0].name;
        reader.onload = function(event){
          var csv = event.target.result;

          //console.log(csv);
          vm.parse_csv = vm.csvJSON(csv)
        };
        reader.onerror = function(evt){
          if(evt.target.error.name=='NotReadableError'){
            this.$store.commit("global/SET_ALERT", {
              msg: "Cannot read File !",
              show: true,
              type: "error"
            });
          }
        };
      }
      else{
        this.$store.commit("global/SET_ALERT", {
          msg: "FileReader are not supported in this browser",
          show: true,
          type: "error"
        });
      }
    },



    csvJSON(csv){
      try {
        let vm = this
        let Stops = [];
        let lines = csv.split("\n")
        let result = []
        let headers = lines[0].split(",")
        vm.parse_header = lines[0].split(",")
        lines[0].split(",").forEach(function (key) {
          vm.sortOrders[key] = 1
        })
        lines.map(function(line, indexLine){
          if (indexLine < 1) return // Jump header line
          let obj = {}
          let currentline = line.split(",")
          headers.map(function(header, indexHeader){
            obj[header] = currentline[indexHeader]
          })
          result.push(obj)
        })
        result.pop() // remove the last item because undefined values
        //console.log(result);

        // console.log(this.arraySchedule)
        let IdsError = "";

        result.forEach((data, index) => {
          let querieStop = {};
          let queriesPlanning = {};

          querieStop.id = data.Id_Parada;

          if(data.shift != "" && data.shift != null){
            this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == data.shift);
            this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
            this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
            this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;


          }
          if (data.schedule == null ||data.schedule == "" )
          {
            querieStop.schedule = "Ninguno"
          }
          else if (data.schedule != null)
          {
            querieStop.schedule = data.schedule

            if(querieStop.schedule == undefined){
              querieStop.schedule = "Ninguno"
            }else{
              querieStop.schedule = data.schedule
            }
          }
          if(querieStop.schedule.length>=4 && querieStop.schedule.length<5){
            querieStop.schedule = "0"+ querieStop.schedule;
          }

          if(querieStop.schedule !="Ninguno" && querieStop.schedule != null && this.ValidateScheduleEdit[0] != null){
            if(querieStop.schedule+":00"  >= this.ValidateScheduleEdit[0].start_time && querieStop.schedule+":00"  <= this.ValidateScheduleEdit[0].end_time)
            {
              querieStop.error = false;

            }
            else if(this.ValidateScheduleEdit[0].end_time <= this.ValidateScheduleEdit[0].start_time){

              if((querieStop.schedule+":00"   >= this.ValidateScheduleEdit[0].start_time)||(querieStop.schedule+":00"  >= '00:00' && querieStop.schedule+":00"  <= this.ValidateScheduleEdit[0].end_time)){
                querieStop.error = false;
              }
              else{
                queriesPlanning.error = true;
                querieStop.error = true;
                IdsError = IdsError + ",Horario:" + querieStop.id;
              }
            }
            else{
              queriesPlanning.error = true;
              querieStop.error = true;
              IdsError = IdsError + ",Horario:" + querieStop.id;
            }
          }
          else if(querieStop.schedule != null) {
            queriesPlanning.error = true;
            querieStop.error = true;
            IdsError = IdsError + ",Horario:" + querieStop.id;
          }

          querieStop.route_id = data.route_id;
          querieStop.route_description = data.Descripcion_Ruta;
          querieStop.stop_description = data.Descripcion_Parada;



          const coordinates = data.coordenates.replace(';', ',');
          const [latitude, longitude]= coordinates.split(",");
          const valCoor = latitude>-90 && latitude<90 && longitude>-180 && longitude<180;
          //console.log(!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/));
          //console.log(valCoor)
          querieStop.coordenates = coordinates;

          if (!coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
            queriesPlanning.error = true;
            querieStop.error = true;
            IdsError = IdsError + ",Coordenadas:" + querieStop.id;
          }
          else{
            if(!valCoor){
              //querieStop.coordenates = coordinates;
              queriesPlanning.error = true;
              querieStop.error = true;
              IdsError = IdsError + ",Coordenadas:" + querieStop.id;
            }
          }




          // if (coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)){
          //     const [latitude, longitude]= coordinates.split(",");
          //     console.log(latitude>-90 && latitude<90 && longitude>-180 && longitude<180);
          //       console.log(coordinates.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/));
          //     if (latitude>-90 && latitude<90 && longitude>-180 && longitude<180) {
          //       querieStop.coordenates = coordinates;
          //     }
          //     else{
          //       queriesPlanning.error = true;
          //       querieStop.error = true;
          //       IdsError = IdsError + ",1COORDENADAS:" + querieStop.id;
          //     }
          // }
          // else
          // {
          //     queriesPlanning.error = true;
          //     querieStop.error = true;
          //     IdsError = IdsError + ",2COORDENADAS:" + querieStop.id;

          // }
          //querieStop.schedule = querieStop.schedule;

          Stops.push(querieStop);

          if(data.period_from_DDMMYYYY != "" && data.period_to_DDMMYYYY != null ){
            //var from =  data.period_from_DDMMYY;
            // from = from.split('/');
            //var validar_from = from[2] + '-' + from[1] + '-' + from[0];

            //moment(fecha2,"YYYY/MM/DD").format('YYYY/MM/DD');


            let period_from = moment(data.period_from_DDMMYYYY,"DD/MM/YYYY").format('YYYY-MM-DD');
            let period_to = moment(data.period_to_DDMMYYYY,"DD/MM/YYYY").format('YYYY-MM-DD');

            //var period_from = moment(data.period_from_YYYYMMDD).format('YYYY-MM-DD');
            //var period_to = moment(data.period_to_YYYYMMDD).format('YYYY-MM-DD');


            if (data.shift <= 0) {
              queriesPlanning.error = true;
              IdsError = IdsError + "Error Turno,";
            }
            if (data.shift == null && data.shift == "")
            {
              queriesPlanning.error = true;
              queriesPlanning.shift = "Ninguno"
              IdsError = IdsError + "," + "Ingrese Turno"
            }
            else if (data.shift != null && data.shift != "")
            {
              queriesPlanning.shift = data.shift;
            }

            let fecha1 = new Date();
            let Now=  moment(fecha1).format('YYYY-MM-DD');

            if(period_from < Now){
              period_from = Now;
            }
            if (period_to < period_from) {
              queriesPlanning.error = true;
              IdsError = IdsError + "Error fecha anterior,";

            }



            // var fecha = new Date();
            // var ValFecha = moment(fecha).format('YYYY-MM-DD');

            //if (period_from > ValFecha) {
            // queriesPlanning.error = true;
            //IdsError = IdsError + "Error Fecha posterior,"
            // }



            queriesPlanning.period_from = period_from;
            queriesPlanning.period_to = period_to;
            queriesPlanning.shift = data.shift;
            queriesPlanning.availableSeats = (Math.floor(data.capacity) - Math.floor(data.blockedSeats));
            queriesPlanning.capacity = Math.floor(data.capacity);
            queriesPlanning.platformsIds = data.idPlatform;
            queriesPlanning.blockedSeats =  Math.floor(data.blockedSeats);
            //queriesPlanning.period_from = period_from;
            //queriesPlanning.period_to = period_to;
            //queriesPlanning.shift = data.shift;
            //queriesPlanning.availableSeats = (data.availableSeats);
            //queriesPlanning.capacity = data.capacity;
            //queriesPlanning.platforms_ids = data.idPlatform;
            //queriesPlanning.blockedSeats =  (data.capacity - data.availableSeats);
            if(data.route_idE == null || data.route_idE ==""){
              queriesPlanning.error = true;
              IdsError = IdsError + "Ingrese ID Ruta"
            }
            else{
              queriesPlanning.route_id = data.route_idE;
            }
            if(data.route_description == null || data.route_description ==""){
              queriesPlanning.error = true;
              IdsError = IdsError + "Ingrese Descripción Ruta"
            }
            else{
              queriesPlanning.route_description = data.route_description;
            }


            //console.log(queriesPlanning.capacity);
            //console.log(queriesPlanning.availableSeats);
            //console.log(queriesPlanning.blockedSeats);

            if (queriesPlanning.capacity  < queriesPlanning.availableSeats) {
              queriesPlanning.error = true;
              IdsError = IdsError + "Capacidad no puede ser Menor";
            }
            if (queriesPlanning.capacity  < queriesPlanning.blockedSeats) {
              queriesPlanning.error = true;
              IdsError = IdsError + "Capacidad no puede ser Menor";
            }
            if(Stops.length ==0){
              queriesPlanning.error = true;
              IdsError = IdsError + "Error: Horarios"
            }


            // VALIDARANDEN
            const ValidaAnden = this.ArrayExtraordinary.findIndex(function (e) {return e.shift === queriesPlanning.shift && e.platformsIds === queriesPlanning.platformsIds });

            //alert(ValidaAnden);
            if(ValidaAnden >= 0)
            {
              queriesPlanning.error = true;
              IdsError = IdsError + ", Andén duplicado"
            }
            queriesPlanning.IdsError = IdsError;

            var Paradas =  Stops.sort(function (a, b) {
              var x = a['schedule'],
                y = b['schedule'];
              return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
            queriesPlanning.stops_ids = Paradas;
            this.ArrayExtraordinary.push(queriesPlanning);
            IdsError = "";
            Stops = [];
          }
        });
        this.cargaFile = true;
        // console.log(this.ArrayExtraordinary);
        return result // JavaScript object
      }
      catch(error){

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }
    },


    ModifyPrePlanning: async function(data,action,edit){

      this.$store.commit("global/SET_LOADING", true);
      try{

        this.typeEdit = edit;
        var IdsError = "";

        if(this.typeEdit == "planning"){
          //const queries = {};
          //queries.planning_id =  data.id; //73;
          //if(data.id != undefined){
          //const resp = await api.Cancellation(queries);
          //this.arrayCancellation =  resp.data;
          //}
          //if(this.arrayCancellation.length)
          //{
          //this.$refs['my-cancellation'].show();
          //}
          const queries = {};
          queries.planningId =  data.id; //73;
          const resp = await api.Cancellation(queries);
          this.arrayCancellation =  resp.data;
          this.EditPrePlanning = "EditExtraordinary";
          this.EnablePlanning = data.enabled;
          this.DeleteRowPreplanning = action;
          this.tableData = [];
          // = data.enable, stops_ids
          this.IdPlanning = data.id;
          this.dates.from = data.period_from;
          this.dates.to = data.period_to;
          this.blockedSeats = data.blockedSeats;
          //this.availableSeats = data.availableSeats;
          this.capacity = data.capacity;
          this.idSchedule = data.shift;
          this.idRoute = data.route_id;
          this.idPlatform = data.platformsIds;
          this.route_description = data.route_description;
          this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
          this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
          this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;

          data.stops_ids.forEach((data, index) => {
            var queries = {};
            queries.route_id = data.route_id;
            queries.route_description = data.route_description;
            queries.id = data.stop_id
            queries.stop_description = data.stop_description;
            queries.coordenates = data.stop_coordenates
            queries.schedule = data.time
            queries.error = data.error

            this.tableData.push(queries);
          });
          this.$refs['Pre-Planning-edit'].show();
          if(this.arrayCancellation.length)
          {
            this.$refs['my-cancellation'].show();
          }
        }
        if(this.typeEdit == "EditExtraordinary")
        {
          this.EditPrePlanning = "EditExtraordinaryMassive";
          this.EnablePlanning = data.enabled;
          this.DeleteRowPreplanning = action;
          this.tableData = [];
          this.dates.from = data.period_from;
          this.dates.to = data.period_to;
          this.blockedSeats = data.blockedSeats;
          //this.availableSeats = data.availableSeats;
          this.capacity = data.capacity;
          this.idSchedule = data.shift;
          this.idRoute = data.route_id;
          this.idPlatform = data.platformsIds;
          this.route_description = data.route_description;
          this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
          this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
          this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;

          data.stops_ids.forEach((data, index) => {
            var queries = {};

            queries.route_id = data.route_id;
            queries.route_description = data.route_description;
            queries.id = data.id;
            queries.stop_description = data.stop_description;
            queries.coordenates = data.coordenates
            queries.schedule = data.schedule
            queries.error = data.error
            this.tableData.push(queries);
          });
          this.$refs['Pre-Planning-edit'].show();
        }

        if(action){
          this.EditPrePlanning = true;
          this.EnablePlanning = data.enabled;
          this.DeleteRowPreplanning = action;
          this.tableData = [];
          this.dates.from = data.period_from;
          this.dates.to = data.period_to;
          this.blockedSeats = data.blockedSeats;
          //this.availableSeats = data.availableSeats;
          this.capacity = data.capacity;
          this.idSchedule = data.shift;
          this.idRoute = data.route_id;
          this.idPlatform = data.platformsIds;
          this.route_description = data.route_description;
          this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
          this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
          this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;

          data.stops_ids.forEach((data, index) => {
            var queries = {};

            queries.route_id = data.route_id;
            queries.route_description = data.route_description;
            queries.id = data.id;
            queries.stop_description = data.stop_description;
            queries.coordenates = data.coordenates
            queries.schedule = data.schedule
            queries.error = data.error
            this.tableData.push(queries);
          });
          this.$refs['Pre-Planning-edit'].show();
        }
        this.$store.commit("global/SET_LOADING", false);
        return;

        if(this.typeEdit == "EditExtraordinary"){
          data.stops_ids.forEach((data, index) => {
            var queries = {};

            this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
            this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
            this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
            this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;
            // queries.numero = numero++
            queries.route_id = data.route_id;
            queries.route_description = data.route_description;
            queries.id = data.id
            queries.stop_description = data.stop_description;
            queries.coordenates = data.coordenates;
            queries.schedule = data.schedule;
            queries.error = data.error;
            if (data.schedule == null)
            {
              queries.schedule = "Ninguno"
            }
            else if (data.schedule != null)
            {
              queries.schedule = data.schedule

              if(queries.schedule == undefined){
                queries.schedule = "Ninguno"
              }else{
                queries.schedule = data.schedule
              }
            }
            if(queries.schedule.length>=4 && queries.schedule.length<5){
              queries.schedule = "0"+ queries.schedule;
            }

            if(queries.schedule !="Ninguno" && queries.schedule != null){
              if(queries.schedule+":00" >= this.ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)
              {
                queries.error = false;

              }
              else if(this.ValidateScheduleEdit[0].end_time <= this.ValidateScheduleEdit[0].start_time){

                if((queries.schedule+":00"  >= this.ValidateScheduleEdit[0].start_time)||(queries.schedule+":00" >= '00:00' && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)){
                  queries.error = false;
                }
                else{
                  queries.error = true;
                  IdsError = IdsError + "," + data.id;
                }
              }
              else{
                queries.error = true;
                IdsError = IdsError + "," + data.id;
              }
            }
            else if(queries.schedule != null) {
              queries.error = true;
              IdsError = IdsError + "," + data.id;
            }


            this.tableData.push(queries);
          });
        }else {
          data.stops_ids.forEach((data, index) => {
            var queries = {};
            // queries.numero = numero++
            queries.route_id = data.route_id;
            queries.route_description = data.route_description;
            queries.id = data.id;
            queries.stop_description = data.stop_description;
            queries.coordenates = data.stop_coordenates;
            queries.schedule = data.time;
            queries.error = data.error;
            this.tableData.push(queries);
          });
        }

        this.$store.commit("global/SET_LOADING", false);
        this.$refs['Pre-Planning-edit'].show();
        // this.tableData = null;
        // this.tableData = data.stops_ids;
        // this.tableData.push(data.stops_ids);

      }
      catch(error){

        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },
  },

  computed:{

    ExtraordinaryTable: function() {
      return this.$refs.ExtraordinaryTable;
    },

    tableAddStops_columns: function() {
      return [
        "Stopschk",
        "route_id",
        // "stop_number",
        "route_description",
        "id",
        "stop_name",
        "coordenates",
        "schedule",
        // "edit",
        // "remove"
      ];
    },

    table_headingsAddStops: function () {
      if (this.tableAddStops_columns) {
        const headings = {};
        this.tableAddStops_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.planning.TableStops.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersAddStops: function () {
      return this.tableAddStops_columns.filter((column) => column !== "edit" && column !== "remove");
    },
    table_optionsAddStops: function () {
      return {
        columns: this.tableAddStops_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsAddStops,
            filterable: this.table_filtersAddStops,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 50,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              select: "select-column",
              id: "id-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },

    planningTable: function() {
      return this.$refs.planningTable;
    },

    // blockedSeats:function(){
    //  return this.capacity - this.availableSeats;
    //},

    availableSeats:function(){
      return   this.capacity - this.blockedSeats;
    },

    appLang: function() {
      return this.$store.getters['settings/currentLang'];
    },


    tableStops_columns: function() {
      return [
        "route_id",
        "route_description",
        "id",
        "stop_description",

        // "stop_name",
        "coordenates",
        "schedule",
        "error",
        "edit",
        "remove"];
    },

    table_headingsStops: function () {
      if (this.tableStops_columns) {
        const headings = {};
        this.tableStops_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.planning.TableStops.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersStops: function () {
      return this.tableStops_columns.filter((column) => column !== "edit" && column !== "remove");
    },
    table_optionsCarga: function () {

      return {
        columns: this.tableStops_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsStops,
            filterable: this.table_filtersStops,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 10,
            perPageValues: [5, 25, 50, 100],
            columnsClasses: {
              select: "select-column",
              id: "id-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },

    table_extraordinary_columns: function(){
      return [
        //"enable",
        "period_from",
        "period_to",
        "platformsIds",
        "route_id",
        "route_description",
        "shift",
        "blockedSeats",
        "availableSeats",
        "capacity",
        "error",
        "actions",
        "eliminar"
      ]
    },

    table_extrordinary_headings: function() {
      if (this.table_extraordinary_columns) {
        const headings = {};
        this.table_extraordinary_columns.forEach(column => {
          headings[column] = this.$t(
            `bookingTransport.planning.TablePlanning.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },

    table_filters_extraordinary: function () {
      return this.table_extraordinary_columns.filter((column) => column !== "actions" && column !== "eliminar" && column !== "error"  && column !== "period_from" && column !== "period_to");
    },

    table_options_extraordinary: function () {

      return {
        columns: this.table_extraordinary_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_extrordinary_headings,
            filterable: this.table_filters_extraordinary,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 10,
            perPageValues: [5,10, 25, 50, 100],
            columnsClasses: {
              created_at: "created_at",
              //period_from: "actions-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },

    tableAddCancelation_columns: function() {
      return [
        // "enable",
        "reservation",
        "id",
        "created_at",
        "enabled",
        "period_from",
        "period_to",
        "platforms_ids",
        "route_id",
        "shift",
        "availableSeats",
        "blockedSeats",
        "capacity",
        // "stops_ids",

      ];
    },

    table_headingsAddCancelation: function () {
      if (this.tableAddCancelation_columns) {
        const headings = {};
        this.tableAddCancelation_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.planning.TableCancelation.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersAddCancelation: function () {
      return this.tableAddCancelation_columns.filter((column) => column !== "edit" );
    },
    table_optionsAddCancelation: function () {
      return {
        columns: this.tableAddCancelation_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsAddCancelation,
            filterable: this.table_filtersAddCancelation,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 50,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              select: "select-column",
              id: "id-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableCancelation.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableCancelation.headings.limit")
            },
          },
      };
    },


    table_columns: function() {
      return [
        "id",
        "created_at",
        "carritochk",
        "enabled",
        "period_from",
        "period_to",
        "platformsIds",
        //"route_id",
        "route_description",
        "shift",
        "blockedSeats",
        "availableSeats",
        "capacity",
        // "stops_ids",
        "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `bookingTransport.planning.TablePlanning.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions" && column !== "carritochk"&& column !== "enabled");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
          columnsClasses: {
            created_at: "select-columncreated_at",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("bookingTransport.planning.TablePlanning.headings.column_toggler"),
            limit: this.$t("bookingTransport.planning.TablePlanning.headings.limit")

          },

          requestAdapter: function(data) {
            const queries = {};
            queries.action = "list"
            queries.pagination= {all:false,
              limit:data.limit,
              page:data.page
            };
            var jsonRequest = {route_type: "extraordinary"};
            let xquery = Object.assign(jsonRequest, data.query)
            queries.filters =  xquery;

            return queries;

          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {

              const resp = await api.Planning(data);
              this.$store.commit("global/SET_LOADING", false);
              // console.log(resp);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: `${error}`,
                show: true,
                type: "error"
              });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.data,
              count: response.total
            };
          }
        }


      };
    }



  },



  filters: {
    formatDateOnly: function(value, lang) {
      if (!value) return '';
      if (lang === 'es') {
        moment.locale("es-do");
      } else {
        moment.locale("en");
      }
      return moment(value).utc().format('YYYY-MM-DD')
    },
  }
}



</script>
<style lang="scss">

.noEditable {
  background-color: #e4e7ea;
  font-stretch: normal;
  font-style: normal;
  font-variant: normal;
  font-weight: bold;
  letter-spacing: normal;
  line-height: normal;
  text-decoration: none;
  text-transform: none;
}

#ExtraordinaryTable .table-responsive {
  height:auto;
  width: auto;
  overflow:scroll;
}
.container-input {
  text-align: center;
  background: #fff; //#b6b0b0;
  top: 30px;
  border-top: 5px solid #fff; //#000000;
  padding: 5px 0;
  border-radius: 6px;
  width: 70%;
  height: 70%;
  margin: 0 auto;
  margin-bottom: 1em;
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

}

.inputfile + label {
  max-width: 100%;
  font-size: 1.35rem;
  font-weight: 200;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}

.inputfile + label i {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.05em;
}

.iborrainputfile {
  font-size:14px;
}

.inputfile-2 + label {
  color: #fff;
  background-color: #000000;
}

.inputfile-2:focus + label,
.inputfile-2.has-focus + label,
.inputfile-2 + label:hover {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #000000;
}




#AddCancelationMassive .table-responsive {
  height:400px;
  width: auto;
  overflow:scroll;
}


.VueTables__created_at-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#created_at{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.VueTables__period_from-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#period_from{
  position: absolute;
  top: 20%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.VueTables__period_to-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#period_to{
  position: absolute;
  top: 20%;
  z-index: 10;
  width:auto;
  visibility:visible;
}

// #planningTable .select-columncreated_at{
//     // position: sticky;
//     left: 0;
//     text-align: center;
//     width:auto;

//   }

.error-msg {
  color: $warn_red;
  font-size: 14px;
}

#Planning-booking {
  background-color: $white;
  padding: 2rem 4rem;
}

#PrePlanningTable .table-responsive {
  height:500px;
  width: auto;
  overflow:scroll;
}

.actions-column {
  position: relative;
  z-index: 1;
  left: 0;
  text-align: center;
  width: 5%;
}




#PlanningStops .table-responsive {
  height:300px;
  overflow:scroll;
}

#AddStops .table-responsive {
  height:300px;
  overflow:scroll;
}

.btn-confirm {
  padding:0.5rem 0.5rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
  font-size: 18px;
  // height: 48px;
  width: 162px;


}

.btn-AddStops {
  margin-right: 3rem;
  padding:1rem 1rem;
  height: 80%;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
}



</style>

